import { render, staticRenderFns } from "./CommercialProgramming.vue?vue&type=template&id=316ea4cb&scoped=true"
import script from "./CommercialProgramming.vue?vue&type=script&lang=js"
export * from "./CommercialProgramming.vue?vue&type=script&lang=js"
import style0 from "./CommercialProgramming.vue?vue&type=style&index=0&id=316ea4cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ea4cb",
  null
  
)

export default component.exports